import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#120E03] text-[#FFF4D6] pt-20 pb-8 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="flex flex-col md:flex-row justify-between gap-10">
        <div>
          <Logo light />
          <p className="mt-4 max-w-xs text-[#D9CCAA]">Cold-pressed watermelon, pineapple and apple juice, bottled fresh.</p>
        </div>
        <div className="flex gap-10 text-sm font-semibold">
          <Link to="/" data-testid="footer-home-link" className="hover:text-[#FFD000] transition-colors">Home</Link>
          <Link to="/shop" data-testid="footer-shop-link" className="hover:text-[#FFD000] transition-colors">Shop</Link>
          <a href="mailto:support@sweetjuice.net" data-testid="footer-email-link" className="hover:text-[#FFD000] transition-colors">support@sweetjuice.net</a>
        </div>
      </div>
      <p className="font-display font-extrabold tracking-[-0.05em] text-[#FFD000] text-[15vw] leading-none mt-16 select-none">sweetjuice</p>
      <div className="mt-6 flex justify-between text-xs text-[#BFB08C]">
        <span>© {new Date().getFullYear()} sweetjuice.com</span>
        <span>Made with fruit, not syrup.</span>
      </div>
    </div>
  </footer>
);
